import store from '../store';

export const getCurrentPassFromStore = () => {
  if (!store || !store.getState()) {
    return;
  }
  return store.getState().citraData?.pass?.currentPass;
};